// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { Divider, Stack } from '@mantine/core';
import type { Communication } from '@medplum/fhirtypes';
import { isRead } from '@polarissleep/shared';
import type { JSX } from 'react';
import { Fragment } from 'react';
import { ChatListItem } from './ChatListItem';

interface ChatListProps {
  threads: [Communication, Communication | undefined][];
  selectedCommunication: Communication | undefined;
  getThreadUri: (topic: Communication) => string;
  /** Reference of the current user; used to decide which threads render as unread (bold). */
  currentUserRef?: string;
}

export const ChatList = (props: ChatListProps): JSX.Element => {
  const { threads, selectedCommunication, getThreadUri, currentUserRef } = props;

  return (
    <Stack gap={0}>
      {threads.map((thread: [Communication, Communication | undefined]) => {
        const topicCommunication = thread[0];
        const lastCommunication = thread[1];
        const _isSelected = selectedCommunication?.id === topicCommunication.id;
        const unread =
          !!currentUserRef &&
          !!lastCommunication &&
          lastCommunication.sender?.reference !== currentUserRef &&
          !isRead(lastCommunication);
        return (
          <Fragment key={topicCommunication.id}>
            <ChatListItem
              topic={topicCommunication}
              lastCommunication={lastCommunication}
              isSelected={_isSelected}
              unread={unread}
              getThreadUri={getThreadUri}
            />
            <Divider />
          </Fragment>
        );
      })}
    </Stack>
  );
};
